import { heatRank } from '@/mocks/homeContent';

export default function TrendRank() {
  return (
    <section id="rank" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        {/* section header */}
        <div className="mb-10 flex flex-col gap-4 md:mb-14 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-primary-600">
              <span className="h-px w-8 bg-primary-500"></span> Trend Ranking
            </span>
            <h2 className="mt-3 font-display text-3xl font-black text-foreground-950 md:text-4xl">
              今日热度榜 <span className="text-primary-600">·</span> 谁在刷屏
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-foreground-600">
            按全网讨论热度实时更新，只收录正在被反复转发、逐条回放的那一条。榜单即瓜田的入口。
          </p>
        </div>

        <div className="grid gap-x-10 gap-y-4 md:grid-cols-2">
          {heatRank.map((item) => {
            const hot = item.rank <= 3;
            return (
              <a
                key={item.rank}
                href="#featured"
                className="group flex items-center gap-4 rounded-lg px-2 py-4 transition-colors hover:bg-background-100 cursor-pointer md:gap-6"
              >
                {/* index */}
                <span
                  className={`flex h-12 w-12 shrink-0 items-center justify-center font-display text-3xl font-black tabular ${
                    item.rank === 1
                      ? 'text-primary-500'
                      : item.rank === 2
                        ? 'text-accent-500'
                        : item.rank === 3
                          ? 'text-secondary-500'
                          : 'text-foreground-300'
                  }`}
                >
                  {String(item.rank).padStart(2, '0')}
                </span>

                {/* body */}
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="text-[11px] font-medium text-secondary-500">#{item.type}</span>
                    <span
                      className={`rounded-full px-2 py-0.5 text-[10px] font-semibold whitespace-nowrap ${
                        hot ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-700'
                      }`}
                    >
                      爆火
                    </span>
                  </div>
                  <h3 className="mt-1 truncate text-base font-bold text-foreground-900 group-hover:text-primary-700 transition-colors">
                    {item.title}
                  </h3>
                </div>

                {/* heat */}
                <div className="hidden shrink-0 flex-col items-end gap-1.5 sm:flex">
                  <div className="flex items-center gap-1 text-sm font-black tabular text-foreground-800">
                    {item.heat}
                    <i className={`text-[10px] ${item.up ? 'ri-arrow-up-line text-primary-500' : 'ri-arrow-down-line text-accent-600'}`}></i>
                  </div>
                  <div className="h-1.5 w-24 overflow-hidden rounded-full bg-background-200">
                    <div
                      className={`h-full rounded-full ${hot ? 'bg-primary-500' : 'bg-secondary-300'}`}
                      style={{ width: `${item.heat}%` }}
                    ></div>
                  </div>
                  <span className={`text-[10px] tabular ${item.up ? 'text-primary-500' : 'text-accent-600'}`}>
                    {item.trend} 热度
                  </span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}